import { ColumnSortEvent } from 'primereact/column';

export const extractField = <T>(data: T, field: string): any => {
  const fields = field.split('.');
  let value: any = data;
  for (const f of fields) {
    value = value[f as keyof typeof value];
    if (value === undefined) {
      return null;
    }
  }
  return value;
};

export const customSort = <T>(data: T[], event: ColumnSortEvent): T[] => {
  const { field, order } = event;
  if (order === undefined || order === null) return data;
  const sortedData = [...data].sort((a, b) => {
    const valueA = extractField(a, field);
    const valueB = extractField(b, field);
    if (
      (valueA === null && valueB === null) ||
      (valueA === undefined && valueB === undefined)
    )
      return 0;
    if (valueA === null || valueA === undefined) return -1;
    if (valueB === null || valueB === undefined) return 1;

    // Assuming label exists on the extracted field, adjust this part if needed
    if (valueA.label < valueB.label) return order;
    if (valueA.label > valueB.label) return -order;
    return 0;
  });
  return sortedData;
};
